<!-- 列表懒加载 -->
<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list :immediate-check="false" v-model="loading" :finished="finished" :finished-text="list.length == 0 ? '' : '暂无更多了'" @load="onLoad">
                <template #default>
                    <!-- 通过作用域插槽将数据丢给父组件 -->
                    <slot name="default" :dataList="list"></slot>
                </template>
            </van-list>
        </van-pull-refresh>
        <van-empty class="empty-position" :description="description" v-if="list.length == 0 && finished" />
    </div>
</template>

<script>
import { throttle } from "@/libs/tools";
export default {
    name: "LazyLoadList",
    props: {
        //查询函数
        getData: {
            type: Function,
            require: true,
        },
        //查询参数,初始化后 page默认重置为0
        query: {
            type: Object,
            require: true,
            default: () => {},
        },
        description: {
            type: String,
            default: "暂无记录",
        },
    },
    data() {
        return {
            loading: false,
            finished: false,
            refreshing: false,
            list: [],
        };
    },
    watch: {
        newValue: {
            handler(newValue, oldValue) {
                console.log(newValue);
                //当query参数发送变化时监听调用（除了pageSize、page改变）
                let flag = Object.entries(newValue).toString() === Object.entries(oldValue).toString();
                if (!flag) {
                    console.log("除了pageSize、page改变");
                    console.log("oldValue:", oldValue);
                    console.log("newValue:", newValue);
                    this.query.pageNum = 0;
                    this.finished = false;
                    this.loading = false;
                    this.refreshing = false;
                    this.list = [];
                    this.onLoad();
                }
            },
        },
    },

    computed: {
        newValue() {
            let objKeysArr = Object.keys(this.query);
            let changeProperty = { ...this.query };
            if (objKeysArr.length > 2) {
                //一般查询query 为 page、pageSize、...其他参数
                delete changeProperty.pageNum;
                delete changeProperty.pageSize;
                return changeProperty;
            }
        },
    },
    mounted() {
        //当查询query 为 page、pageSize 通过mounted调用，否则通过watch监听调用
        let objKeysArr = Object.keys(this.query);
        if (objKeysArr.length == 2) {
            this.onLoad();
        }
    },

    methods: {
        //临界时可能会多次触发，异步还没返回时，可能会再次触发
        onLoad: throttle(function () {
            console.log("onLoadss");
            console.log(this.loading);
            this.query.pageNum += 1;

            if (this.refreshing) {
                this.list = [];
                this.refreshing = false;
                this.query.pageNum = 1;
            }

            this.getData(this.query).then((res) => {
                if (res.code == 200) {
                    if (this.query.pageNum == 1) {
                        this.$emit("getList", res.data);
                    }
                    if (res.data.rows != null) this.list = [...this.list, ...res.data.rows];
                    //最后一页 length小于10
                    if (res.data.rows == null || (res.data.rows && res.data.rows.length < 10)) {
                        this.finished = true;
                    }
                }

                console.log(this.finished);

                this.loading = false;
            });
        }, 200),

        onRefresh() {
            console.log("onRefresh");
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
    },
};
</script>
<style lang="less" scoped>
.empty-position {
    margin-top: 100px;
}
</style>
